import toast from "react-hot-toast";
import { supabase } from ".";

export const getFacturasComision2 = async ({ edificio, fechas, pais }) => {
  try {
    const data = await supabase.select("sales", {
      filters: {
        pais: pais, // Direct string value, becomes pais=eq.Perú
        facturafecha: {
          gte: fechas[0],
          lte: fechas[1],
        },
        edificiosparticipantes: { like: String(edificio) },
        eliminada: !true,
      },
    });

    const filteredData = data.filter((sale) => {
      const edificiosList = sale.edificiosparticipantes ? sale.edificiosparticipantes.split(",") : [];
      return edificiosList.includes(String(edificio));
    });

    // Vacío legítimo (edificio sin facturas en el período): retornar [] sin cartel de error.
    return filteredData;
  } catch (error) {
    // Solo errores reales (excepción de red / fallo de query) muestran toast.
    toast.error(`Error al obtener facturas del edificio: ${error.message}`);
    return [];
  }
};
